import Nullstack from 'nullstack';
export default function IconBrandLaravel({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-brand-laravel",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M3 17l8 5l7 -4v-8l-4 -2.5l4 -2.5l4 2.5v4l-11 6.5l-4 -2.5v-7.5l-4 -2.5z"
  }), "   ", Nullstack.element("path", {
    d: "M11 18v4"
  }), "   ", Nullstack.element("path", {
    d: "M7 15.5l7 -4"
  }), "   ", Nullstack.element("path", {
    d: "M14 7.5v4"
  }), "   ", Nullstack.element("path", {
    d: "M14 11.5l4 2.5"
  }), "   ", Nullstack.element("path", {
    d: "M11 13v-7.5l-4 -2.5l-4 2.5"
  }), "   ", Nullstack.element("path", {
    d: "M7 8l4 -2.5"
  }), "   ", Nullstack.element("path", {
    d: "M18 10l4 -2.5"
  }), " ");
}